var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 16,
    viewBox: "0 0 60 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 16V0H4.66675V5.33333H10.0001V0H14.0001V16H10.0001V9.33333H4.66675V16H0.666748ZM20.6667 16V4H16.6667V0H28.6667V4H24.6667V16H20.6667ZM35.3334 16V4H31.3334V0H43.3334V4H39.3334V16H35.3334ZM46.0001 16V0H55.3334C56.4001 0 57.3334 0.399999 58.1334 1.2C58.9334 2 59.3334 2.93333 59.3334 4V6.66667C59.3334 7.73333 58.9334 8.66667 58.1334 9.46667C57.3334 10.2667 56.4001 10.6667 55.3334 10.6667H50.0001V16H46.0001ZM50.0001 6.66667H55.3334V4H50.0001V6.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushProfile);
export default __webpack_public_path__ + "static/media/pushProfile.a1fb3ab64af0601433e00b85cbcd2b8a.svg";
export { ForwardRef as ReactComponent };